import * as React from "react";
import { SVGProps } from "react";

const Verge = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Lag_1"
    x={0}
    y={0}
    viewBox="0 0 218 251"
    {...props}
  >
    <style>{".st0{fill:#37bde2}"}</style>
    <path d="m184.2 0-74.8 172L34.7 0H0l109.4 251.9L218.9 0z" className="st0" />
    <path d="M109.4 92.6 148.6 0H70.2z" className="st0" />
  </svg>
);

export default Verge;
